module.exports = __webpack_public_path__ + "static/media/weihnachtshintergrund.6934e033.png";